import {ContactNote, type ContactNoteData} from "@/types/contacts/contactNote";
import {ContactFile, type ContactFileData} from "@/types/contacts/contactFile";
import {CompanyNote, type CompanyNoteData} from "@/types/company/companyNote";
import {Company,type CompanyData} from "@/types/company/company";

export class Contact {
    public id: number | null;
    public company_id: number | null;
    public first_name: string;
    public last_name: string;
    public phone_number: string;
    public email: string;
    public title: string;
    public departament: string | null;
    public role_id: number | null;
    public report_to_id: number | null;
    public gender_id: number | null;
    public language_id: number | null;
    public other_language: string | null;
    public date_of_birth: Date | null;
    public date_of_birth_consent: number ;
    public email_consent: number ;
    public mailing_address_consent: number ;
    public image_data: string | null;
    public country: number | null;
    public county: string | null;
    public address: string | null;
    public city: string | null;
    public zip_code: string | null;
    public createdAt: Date | null;
    public updatedAt: Date | null;
    public deletedAt: Date | null;
    public created_by_user: string;
    public updated_by_user: string;
    public image_contents:string;
    public image_type:string;
    public inactive:number;
    public contactNotes: ContactNote[];
    public companyNotes: CompanyNote[];
    public contactFiles: ContactFile[];
    public company: Company | null;
    public inactivated_by_user_id: number | null;
    public inactivated_at: Date | null;

    constructor(data: ContactData | void) {
        if (data === undefined) {
            this.id = null;
            this.company_id = null;
            this.first_name = "";
            this.last_name = "";
            this.phone_number = "";
            this.email = "";
            this.title = "";
            this.departament = "";
            this.role_id = null;
            this.report_to_id = null;
            this.gender_id = null;
            this.language_id = null;
            this.other_language = "";
            this.date_of_birth = null;
            this.date_of_birth_consent = 0;
            this.email_consent = 0;
            this.mailing_address_consent = 0;
            this.image_data = null;
            this.country = 182;
            this.county = null;
            this.address = "";
            this.city = "";
            this.zip_code = "";
            this.createdAt = null;
            this.updatedAt = null;
            this.deletedAt = null;
            this.created_by_user = "";
            this.updated_by_user = "";
            this.image_contents = '';
            this.image_type = '';
            this.inactive = 0;
            this.contactNotes = [];
            this.companyNotes = [];
            this.contactFiles = [];
            this.company = null;
            this.inactivated_by_user_id = 0;
            this.inactivated_at = null;
        } else {
            this.id = data.id;
            this.company_id = data.company_id;
            this.first_name = data.first_name;
            this.last_name = data.last_name;
            this.phone_number = data.phone_number;
            this.email = data.email;
            this.title = data.title;
            this.departament = data.departament;
            this.role_id = data.role_id;
            this.report_to_id = data.report_to_id;
            this.gender_id = data.gender_id;
            this.language_id = data.language_id;
            this.other_language = data.other_language;
            this.date_of_birth_consent = data.date_of_birth_consent;
            this.email_consent = data.email_consent;
            this.mailing_address_consent = data.mailing_address_consent;
            this.image_data = data.image_data;
            this.country = data.country;
            this.county = data.county;
            this.address = data.address;
            this.city = data.city;
            this.zip_code = data.zip_code;
            this.createdAt = data.createdAt;
            this.updatedAt = data.updatedAt;
            this.deletedAt = data.deletedAt;
            this.created_by_user = data.created_by_user;
            this.updated_by_user = data.updated_by_user;
            this.image_contents = data.image_contents;
            this.image_type = data.image_type;
            this.inactive = data.inactive;
            this.contactNotes = [];
            if (data.contactNotes !== undefined) {
                data.contactNotes.forEach(contactNote => this.contactNotes.push((new ContactNote(contactNote))));
            }
            this.companyNotes = [];
            if (data.companyNotes !== undefined) {
                data.companyNotes.forEach(companyNote => this.companyNotes.push((new CompanyNote(companyNote))));
            }
            this.contactFiles = [];
            if (data.contactFiles !== undefined) {
                data.contactFiles.forEach(contactFile => this.contactFiles.push((new ContactFile(contactFile))));
            }
            this.date_of_birth = null;
            if (data.date_of_birth !== null) {
                this.date_of_birth = new Date(data.date_of_birth);
            }
            this.company = null;
            if (data.company !== undefined && data.company !== null) {
                this.company = new Company(data.company)
            }
            this.inactivated_by_user_id = data.inactivated_by_user_id;
            this.inactivated_at = null;
            if (data.inactivated_at !== null) {
                this.inactivated_at = new Date(data.inactivated_at);
            }
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.company_id = 0;
        this.first_name = "";
        this.last_name = "";
        this.phone_number = "";
        this.email = "";
        this.title = "";
        this.departament = "";
        this.role_id = null;
        this.report_to_id = null;
        this.gender_id = null;
        this.language_id = null;
        this.other_language = "";
        this.date_of_birth = new Date();
        this.date_of_birth_consent = 0;
        this.mailing_address_consent = 0;
        this.email_consent = 0;
        this.image_data = null;
        this.country = 182;
        this.county = "";
        this.address = "";
        this.city = "";
        this.zip_code = "";
        this.createdAt = null;
        this.updatedAt = null;
        this.deletedAt = null;
        this.created_by_user = "";
        this.updated_by_user = "";
        this.contactNotes = [];
        this.companyNotes = [];
        this.contactFiles = [];
        this.inactivated_by_user_id = 0;
        this.inactivated_at = null;
    }

    public getFullName(): string {
        return `${this.first_name} ${this.last_name}`;
    }

    getInitials(glue: boolean | undefined): string | Array<string> {
        if (typeof glue === "undefined") {
            glue = true;
        }
        const first_name = this.first_name.charAt(0);
        const last_name = this.last_name.charAt(0);
        let full_name = `${first_name} ${last_name}`;

        const initials = full_name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

        if (initials === null) {
            if (glue) {
                return "";
            } else {
                return [];
            }
        }

        if (glue) {
            return initials.join('');
        }

        return initials;
    };

    getProfilePicture(): string | null {
        return `data:${this.image_type};base64,${this.image_contents}`;
    }

    serializeData(without_relations: boolean | Array<string> = false) {
        const serialized_data = {
            id: this.id,
            company_id: this.company_id,
            first_name: this.first_name,
            last_name: this.last_name,
            phone_number: this.phone_number,
            email: this.email,
            title: this.title,
            departament: this.departament,
            role_id: this.role_id,
            report_to_id: this.report_to_id,
            gender_id: this.gender_id,
            language_id: this.language_id,
            other_language: this.other_language,
            date_of_birth: this.date_of_birth,
            date_of_birth_consent: this.date_of_birth_consent,
            mailing_address_consent: this.mailing_address_consent,
            email_consent: this.email_consent,
            image_data: this.image_data,
            country: this.country,
            county: this.county,
            address: this.address,
            city: this.city,
            zip_code: this.zip_code,
            inactive: this.inactive,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            deletedAt: this.deletedAt,
            created_by_user: this.created_by_user,
            updated_by_user: this.updated_by_user,
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('contactNotes')
            )
        ) {
            serialized_data.contactNotes = [];
            this.contactNotes.forEach(el => {
                serialized_data.contactNotes.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyNotes')
            )
        ) {
            serialized_data.companyNotes = [];
            this.companyNotes.forEach(el => {
                serialized_data.companyNotes.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('contactFiles')
            )
        ) {
            serialized_data.contactFiles = [];
            this.contactFiles.forEach(el => {
                serialized_data.contactFiles.push(el.serializeData())
            })
        }

        return serialized_data;
    }
}

export type ContactData = {
    id: number | null;
    company_id: number;
    first_name: string;
    last_name: string;
    phone_number: string;
    email: string;
    title: string;
    departament: string | null;
    role_id: number | null;
    report_to_id: number | null;
    gender_id: number | null;
    language_id: number | null;
    other_language: string | null;
    date_of_birth: Date | null;
    date_of_birth_consent: number ;
    email_consent: number ;
    mailing_address_consent: number ;
    image_data: string | null,
    country: number | null;
    county: string | null;
    address: string | null;
    city: string | null;
    zip_code: string | null;
    createdAt: Date | null;
    updatedAt: Date | null;
    deletedAt: Date | null;
    created_by_user: string;
    updated_by_user: string;
    image_contents:string;
    image_type:string;
    inactive:number;
    contactNotes: ContactNoteData[] | undefined;
    companyNotes: CompanyNoteData[] | undefined;
    contactFiles: ContactFileData[] | undefined;
    company:CompanyData|null;
    inactivated_by_user_id: number | null;
    inactivated_at: Date | null;
}